module.exports = __webpack_public_path__ + "static/media/index.fc3a2c09.jpg";